import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { CitySVG } from '@common_components/svg/city.svg';

const CityIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <CitySVG/>
    </div>
  );
};

export { CityIcon };
